import { render, staticRenderFns } from "./source_post_count.vue?vue&type=template&id=5addbb52"
import script from "./source_post_count.vue?vue&type=script&lang=js"
export * from "./source_post_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports